export const removenbspfromjobdestails = () => {
    const jobdescription = document.querySelector<HTMLElement>(
        " .page-job-details .description-widget"
    );

    if (!jobdescription) return;

    jobdescription.innerHTML = jobdescription.innerHTML.replace(
        /\&nbsp;/g,
        " "
    );
};